// aiAuthToken — Resolverar Authorization-token för AI-edge-endpoints.
//
// Prefererar user-session-token (så edge får user-claims för tier-gate,
// per-user-rate-limit, user_id-loggning i ai_ops_event) och faller
// tillbaka till anon-key för icke-inloggade users (edge-funktionen
// accepterar båda).
//
// Se IMPROVEMENTS.md S-010.

/**
 * Returnerar den token som ska användas i `Authorization: Bearer <...>`-
 * headern för anrop mot `ai-workflow-assistant`-edge-funktionen.
 *
 * Regler:
 * - `userSessionToken` (från `supabase.auth.getSession()`) har företräde
 *   — den ger edge-funktionen user-claims.
 * - Tom sträng räknas som "ingen token" så anon-key används.
 * - `anonKey` är fallback; om båda saknas returneras en tom sträng
 *   (callern får då 401 från edge vilket är förväntat beteende).
 */
export function resolveAiAuthToken(
  userSessionToken: string | null | undefined,
  anonKey: string | null | undefined,
): string {
  const user = (userSessionToken ?? '').trim();
  if (user.length > 0) return user;
  return (anonKey ?? '').trim();
}
